
// import { forgetPassword } from "@/api/login";
import md5 from 'js-md5'
import LoginTemplate from '@/components/LoginTemplate'

export default {
	components: {
		LoginTemplate
	},
	head() {
		return {
			title: this.$config.isPublicProd ? '忘记密码-盼之代售' : '测试',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: this.$config.isPublicProd
						? '盼之代售账号忘记密码，盼之代售专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等'
						: ''
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: this.$config.isPublicProd ? '忘记密码，盼之代售' : ''
				}
			]
		}
	},
	data() {
		const validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			passwordType: 'password',
			passwordNewType: 'password',
			ruleForm: {
				mobile: '',
				code: '',
				password: '',
				newPassword: ''
			},
			rules: {
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
						required: true,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}
				],
				code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				password: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{
						pattern:
							/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[a-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$/,
						required: true,
						message: '请输入重新密码',
						trigger: 'blur'
					}
				],
				newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }]
			},
			checked: false,
			loginSate: true,
			regSate: false,
			show: true,
			count: 0,
			timer: null,
			submitLoading: false,
			smsLoading: false,
			verification: true
		}
	},
	methods: {
		blurPassword(key) {
			let passwordPattern =
				/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[a-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$/
			if (key === 'password') this.verification = passwordPattern.test(this.ruleForm.password)
			else this.verification = passwordPattern.test(this.ruleForm.newPassword)
		},
		getCode() {
			const TIME_COUNT = 60
			if (!this.timer) {
				this.count = TIME_COUNT
				this.show = false
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--
					} else {
						this.show = true
						clearInterval(this.timer)
						this.timer = null
						this.smsLoading = false
					}
				}, 1000)
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.submitLoading = true
					if (this.ruleForm.password !== this.ruleForm.newPassword) {
						this.$message.warning('您两次输入的密码不一致，请重新输入')
						return false
					} else {
						let params = {
							action: {
								phone: this.ruleForm.mobile.trim(),
								smsCode: this.ruleForm.code,
								password: md5(this.ruleForm.password)
							}
						}
						this.$api
							.forgetPassword(params)
							.then(res => {
								if (res.success) {
									this.$message({
										center: true,
										duration: 2600,
										dangerouslyUseHTMLString: true,
										message: '<i class="el-icon-loading text-909399"></i><span class="ml-5">修改成功，请保管好您的密码。正为您跳转至登录页面...</span>'
									})
									setTimeout(() => {
										this.$router.push('/login')
									}, 2600)
									this.submitLoading = false
								} else {
									this.submitLoading = false
									this.$message.error(res.info)
								}
							})
							.catch(() => {
								this.submitLoading = false
							})
					}
				} else {
					return false
				}
			})
		},
		sendSms() {
			if (this.ruleForm.mobile === '') {
				this.$message.error('请输入手机号')
				this.$refs.phone.focus()
				return false
			} else {
				this.smsLoading = true
				let data = {
					action: {
						phone: this.ruleForm.mobile,
						smsTemplate: 'MOD'
					}
				}
				this.$store
					.dispatch('user/UserSendSms', data)
					.then(res => {
						this.smsLoading = false
						if (res.success) {
							this.$message.success('验证码已发送，请注意查收')
							this.getCode()
							this.$refs.code.focus()
							return false
						} else {
							this.$message.warning(res.info)
						}
					})
					.catch(() => {
						this.smsLoading = false
						this.timer = null
					})
			}
		},
		showPwd(key) {
			if (key === 'password') {
				if (this.passwordType === 'password') {
					this.passwordType = ''
				} else {
					this.passwordType = 'password'
				}

				this.$nextTick(() => {
					this.$refs.password.focus()
				})
			} else {
				if (this.passwordNewType === 'password') {
					this.passwordNewType = ''
				} else {
					this.passwordNewType = 'password'
				}

				this.$nextTick(() => {
					this.$refs.newPassword.focus()
				})
			}
		}
	}
}
